/* eslint-disable */
import { createStore, applyMiddleware, compose } from "redux";
import { createLogger } from "redux-logger";

import rootReducer from "./rootReducer";
import initialState from "./initialState";

const loggerMiddleware = createLogger({ collapsed: true });

const enhancers = [];
const middleware = [...(process.env.NODE_ENV === "development" ? [loggerMiddleware] : [])];

const devToolsExtension = window.devToolsExtension;

if (typeof devToolsExtension === "function") {
  enhancers.push(devToolsExtension());
}

const composedEnhancers = compose(applyMiddleware(...middleware), ...enhancers);

const store = (window.store = createStore(rootReducer, initialState, composedEnhancers));

export default store;



// WEBPACK FOOTER //
// ./src/reducers/store.js